<ppl-form-row>
  <ppl-form-column>
    <ppl-checkbox
      [value]="enabled"
      [disabled]="!canChangePassword"
      i18n="@@Change_password"
      (valueChange)="changePassword.emit($event)"
      >Change password</ppl-checkbox
    >
  </ppl-form-column>
</ppl-form-row>

@if (canChangePassword && enabled) {
  <ng-container [formGroup]="form">
    <ppl-form-row>
      <ppl-form-column>
        <ppl-input-container
          label="Current password"
          i18n-label="@@Current_password"
          [pplFormControl]="form.get('currentPassword')">
          <input
            pplInput
            type="password"
            name="current_password"
            autocomplete="current-password"
            formControlName="currentPassword" />
        </ppl-input-container>
      </ppl-form-column>
    </ppl-form-row>
    <ppl-form-row>
      <ppl-form-column>
        <ppl-input-container
          label="Password"
          i18n-label="@@Password"
          [pplFormControl]="form.get('password1')">
          <input
            pplInput
            type="password"
            name="password1"
            autocomplete="new-password"
            formControlName="password1" />
        </ppl-input-container>
      </ppl-form-column>
      <ppl-form-column>
        <ppl-input-container
          label="Confirm password"
          i18n-label="@@Confirm_password"
          [pplFormControl]="form.get('password2')">
          <input
            pplInput
            type="password"
            name="password2"
            autocomplete="new-password"
            formControlName="password2" />
        </ppl-input-container>
      </ppl-form-column>
    </ppl-form-row>
  </ng-container>
}
